export default __webpack_public_path__ + "static/media/link-alt 1.3ee228f5.svg";